export default {
  namespaced: true, // 空间命名
  state: {
    personalInfo:{
      accessToken: "",
      belong: "",
      code: "",
      headimgurl: "",
      ifLogin: "",
      liveId: "",
      liveNum: "",
      liveState: "",
      loginNum: "",
      loginTime: "",
      loginname: "",
      nickname: "",
      pwd: "",
      qqOpenid: "",
      redirect_url: "",
      registerTime: "",
      towid: "",
      uid: "",
      uname: "",
      url: "",
      wxName: "",
      wxOpenid: "",
      wxUnionid: "",
    },  // 用来存储全局个人信息
    loginDialog: false, // 控制登录对话框显示隐藏
    isUser:false,  // 是否登录
    wxBingType:false,  // 微信是否登录  false  未登录   true  登录
    qqBingType:false,  // QQ是否登录  false  未登录  true  登录
    qqOpenid:"",  // QQ唯一id
    wxOpenid:"",  // 微信唯一id
    loading: false,
    appClient:"",  // 用来存储用户是从什么浏览器打开的
  },
  mutations: {
    editAppClient(state,val){
      state.appClient = val
    },
    showLoading(state) {
      state.loading = true
    },
    hideLoading(state) {
      state.loading = false
    },
    // 控制登录对话框显示隐藏
    editLoginDialog(state,val){
      state.loginDialog = val
    },
    // 是否登录
    editIsUser(state,val){
      state.isUser = val
    },
    // 编辑微信绑定状态
    editWxBingType(state,val){
      state.wxBingType = val
    },
    // 编辑QQ绑定状态
    editQqBingType(state,val){
      state.qqBingType = val
    },
    // 修改个人用用户信息
    editPersonalInfo(state,val){
      state.personalInfo.accessToken= val.accessToken
      state.personalInfo.belong = val.belong
      state.personalInfo.code=val.code
      state.personalInfo.headimgurl=val.headimgurl
      state.personalInfo.ifLogin=val.ifLogin
      state.personalInfo.liveId=val.liveId
      state.personalInfo.liveNum=val.liveNum
      state.personalInfo.liveState=val.liveState
      state.personalInfo.loginNum=val.loginNum
      state.personalInfo.loginTime=val.loginTime
      state.personalInfo.loginname=val.loginname
      state.personalInfo.nickname=val.nickname
      state.personalInfo.pwd=val.pwd
      state.personalInfo.qqOpenid=val.qqOpenid
      state.personalInfo.redirect_url=val.redirect_url
      state.personalInfo.registerTime=val.registerTime
      state.personalInfo.towid=val.towid
      state.personalInfo.uid=val.uid
      state.personalInfo.uname=val.uname
      state.personalInfo.url=val.url
      state.personalInfo.wxName=val.wxName
      state.personalInfo.wxOpenid=val.wxOpenid
      state.personalInfo.wxUnionid=val.wxUnionid
    },
    //   修改头像
    editHeadimgurl(state,val){
      state.personalInfo.headimgurl = val
    }
  },
  actions: {},
};
